import { render } from "./ContactBlock.vue?vue&type=template&id=0af15331&scoped=true"
import script from "./ContactBlock.vue?vue&type=script&lang=js"
export * from "./ContactBlock.vue?vue&type=script&lang=js"

import "./ContactBlock.vue?vue&type=style&index=0&id=0af15331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af15331"]])

export default __exports__